import EmbeddedReport from 'components/EmbeddedReport/EmbeddedReport';
import { type FC } from 'react';

const UsageBySession: FC = () => <EmbeddedReport reportId={243} />;

export default UsageBySession;
